module.exports = __webpack_public_path__ + "static/media/ls.8c4fc51.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ls.mp3
// module id = 8R8w
// module chunks = 110